import React, { useSyncExternalStore } from 'react'
import {
  getApiLoadingSnapshot,
  getServerApiLoadingSnapshot,
  subscribeApiLoading,
} from '../utils/apiLoading'
import { C } from '../utils/constants'

const backdrop = {
  position: 'fixed',
  inset: 0,
  zIndex: 10000,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 14,
  background: 'rgba(29, 107, 107, 0.22)',
  backdropFilter: 'blur(2px)',
  pointerEvents: 'auto',
  cursor: 'wait',
  fontFamily: 'Arial, sans-serif',
}

export default function ApiLoadingOverlay() {
  const inFlight = useSyncExternalStore(
    subscribeApiLoading,
    getApiLoadingSnapshot,
    getServerApiLoadingSnapshot
  )
  if (inFlight === 0) return null

  return (
    <div
      style={backdrop}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <svg
        width="40"
        height="40"
        viewBox="0 0 50 50"
        aria-hidden
        focusable="false"
      >
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke={C.border}
          strokeWidth="4"
        />
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke={C.teal}
          strokeWidth="4"
          strokeLinecap="round"
          strokeDasharray="31.4 100"
        >
          <animateTransform
            attributeName="transform"
            type="rotate"
            from="0 25 25"
            to="360 25 25"
            dur="0.8s"
            repeatCount="indefinite"
          />
        </circle>
      </svg>
    </div>
  )
}
